import React from 'react';
import langConf from "../js/lang";
import ShoppingButton from './ShoppingButton';

class Item extends React.Component {
    constructor(props) {
        super(props);

        this.state = { itemCount: this.props.quantity, spans: 0 };

        this.imageRef = React.createRef();
    }

    // componentDidMount() {
    //     this.imageRef.current.addEventListener('load', this.setSpans);

    // }

    // setSpans = () => {
    //     const height = this.imageRef.current.clientHeight;
    //     const spans = Math.ceil(height / 10 + 1);

    //     this.setState({ spans });
    // };

    onTitleClick = (event) => {
        event.preventDefault();
    }

    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    updateItemCount = (number) => {
        let count = this.state.itemCount + number;
        if (count < 0) {
            this.setState({ itemCount: 0 });
        }
        else {
            this.setState({ itemCount: count });
        }
    }

    handleBuyNowClick = (event) => {
        event.preventDefault();
        this.props.addToCart(this.props.itemNo);
        this.props.changeScreen('cart');
    };

    render() {
        let lang = this.props.lang;
        let images = [];
        images[0] = 'http://sheleg.com/pirsum/course.jpg';
        images[1] = 'http://sheleg.com/pirsum/course1.jpg';
        images[2] = 'http://sheleg.com/pirsum/course2.png';
        let randomMin = 0;
        let randomMax = 3;

        let rnd = Math.floor(randomMin + Math.random() * (randomMax - randomMin));
        //console.log('rnd: ', rnd);
        let currency = this.props.currency === 'ILS' ? langConf[lang].ILS : langConf[lang].USD;
        let price = this.props.currency === "ILS" ? (this.props.priceNis === null || this.props.priceNis === '' ? 0 : this.props.priceNis) : (this.props.priceUsd === null || this.props.priceUsd === '' ? 0 : this.props.priceUsd);
        let name = lang === "hebrew" ? this.props.hebName : this.props.engName;
        let fullDescription = lang === "hebrew" ? this.props.hebDescription : this.props.engDescription;
        //let logoURL = lang === 'hebrew' ? this.props.vendorData.logoUrlHeb : this.props.vendorData.logoUrlEng;
        let pictureURL = this.props.picture !== '' ? this.props.picture : images[rnd];//logoURL;
        //let currentURL = this.props.currentURL;
        let showFullDescription = fullDescription.length < 300 ? true : false;
        let description = showFullDescription ? fullDescription : fullDescription.substring(0, 300);
        let showReadMore = showFullDescription ? false : true;
        let isDisabled = this.props.isfull;


        return (
            <div className="col-12 col-xs-12 panel panel-info" style={{ display: this.props.isVisible ? '' : 'none' }}>
                <div className="panel-heading" onClick={this.onTitleClick}><p style={{textAlign: 'right'}}>{name}</p><p style={{textAlign: 'left'}}>{currency}{this.numberWithCommas(price)}</p></div>
                <div className='panel-body'>
                    <div className='col-12' style={{fontSize: '18px'}}>
                        <img className="image-responsive image-rounded" ref={this.imageRef} src={pictureURL} alt={this.props.picDescription} style={{float: 'right', marginLeft: '5%', marginBottom: '3%'}} />
                            <p style={{ textAlign: 'right', display: 'inline' }}>{`${description}  `}</p>
                            <p style={{ display: 'none', textAlign: 'right' }}>{`${fullDescription}  `}</p>
                            <a href={this.props.currentURL} style={showReadMore ? { display: 'inline' } : { display: 'none' }} onClick={
                                (event) => {
                                    event.preventDefault();
                                    if (event.target.parentElement.children[2].style.display.toString() === 'none') {
                                        event.target.parentElement.children[2].style.display = 'inline';
                                        event.target.parentElement.children[1].style.display = 'none';
                                        event.target.innerText = langConf[lang].readLess;
                                    }
                                    else {
                                        event.target.parentElement.children[2].style.display = 'none';
                                        event.target.parentElement.children[1].style.display = 'inline';
                                        event.target.innerText = langConf[lang].readMore;
                                    }
                                }}>{`... ${langConf[lang].readMore}`}
                            </a>
                    </div>
                    
                    
                    <div className="col-12 col-xs-12">
                        <ShoppingButton
                            lang={this.props.lang}
                            //Variables
                            param={this.props.itemNo}
                            param2={1}
                            tableView={false}
                            btnClassName={"addToCart"}
                            btnDir={"left"}
                            btnSize={``}
                            btnColor={"#509a55"}
                            iconClass={"plus icon"}
                            isDisabled={isDisabled}
                            isVisible={true}
                            //Methods
                            onClick={this.props.addToCart}
                            updateItemCount={this.updateItemCount}
                        />
                        
                        <div className="col-6" style={lang === 'hebrew' ? {} : {}}>
                            <button className={`btn btn-primary btn-block btn-lg`} onClick={this.handleBuyNowClick} style={{}}>
                                {langConf[lang].buyNow}
                            </button>
                        </div>
                    </div>
                    
                </div>
            </div>
        );
    }
}

export default Item;


// render() {
//     let lang = this.props.lang;
//     let images = [];
//     images[0] = 'http://sheleg.com/pirsum/course.jpg';
//     images[1] = 'http://sheleg.com/pirsum/course1.jpg';
//     images[2] = 'http://sheleg.com/pirsum/course2.png';
//     let randomMin = 0;
//     let randomMax = 3;

//     let rnd = Math.floor(randomMin + Math.random() * (randomMax - randomMin));
//     //console.log('rnd: ', rnd);
//     let currency = this.props.currency === 'ILS' ? langConf[lang].ILS : langConf[lang].USD;
//     let price = this.props.currency === "ILS" ? (this.props.priceNis === null || this.props.priceNis === '' ? 0 : this.props.priceNis) : (this.props.priceUsd === null || this.props.priceUsd === '' ? 0 : this.props.priceUsd);
//     let name = lang === "hebrew" ? this.props.hebName : this.props.engName;
//     let fullDescription = lang === "hebrew" ? this.props.hebDescription : this.props.engDescription;
//     //let logoURL = lang === 'hebrew' ? this.props.vendorData.logoUrlHeb : this.props.vendorData.logoUrlEng;
//     let pictureURL = this.props.picture !== '' ? this.props.picture : images[rnd];//logoURL;
//     let currentURL = this.props.currentURL;
//     let showFullDescription = fullDescription.length < 200 ? true : false;
//     let description = showFullDescription ? fullDescription : fullDescription.substring(0, 200);
//     let showReadMore = showFullDescription ? false : true;
//     let isDisabled = this.props.isfull;


//     return (
//         <div className="row col-12 panel panel-default" style={{ display: this.props.isVisible ? '' : 'none' }} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
//             <div className={`col-3 col-xs-4`} style={{}}>
//                 <div className="col-12 card" style={{ textAlign: lang === "hebrew" ? "right" : "left" }}>
//                     <div className="col-12 item">
//                         <div style={{ gridRowEnd: `span ${this.state.spans}` }}>
//                             <img className="ui image" ref={this.imageRef} src={pictureURL} alt={this.props.picDescription} style={this.props.picture !== '' ? {} : {}} />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div className={`col-9 col-xs-8`} style={{}}>
//                 <div className="col-12">
//                     <h4 className="ui header" style={{ textAlign: lang === "hebrew" ? "right" : "left" }}>{name}</h4>
//                     <div className="content" style={{}}>
//                         <a className="header" href={currentURL} onClick={this.onTitleClick} style={{ display: 'none' }}><b>{name}</b></a>
//                     </div>
//                 </div>
//                 <div className="col-12">
//                     <div className="extra price" style={{ textAlign: lang === "hebrew" ? "right" : "left" }}>
//                         <b>{this.numberWithCommas(price)}{currency}</b>
//                     </div>
//                 </div>
//                 <div className="col-12">
//                     <div className="item-description" style={{ textAlign: lang === "hebrew" ? "right" : "left" }}>
//                         <p style={{ display: 'inline' }}>{`${description}  `}</p>
//                         <p style={{ display: 'none' }}>{`${fullDescription}  `}</p>
//                         <a href={this.props.currentURL} style={showReadMore ? { display: 'inline' } : { display: 'none' }} onClick={
//                             (event) => {
//                                 event.preventDefault();
//                                 if (event.target.parentElement.children[2].style.display.toString() === 'none') {
//                                     event.target.parentElement.children[2].style.display = 'inline';
//                                     event.target.parentElement.children[1].style.display = 'none';
//                                     event.target.innerText = langConf[lang].readLess;
//                                 }
//                                 else {
//                                     event.target.parentElement.children[2].style.display = 'none';
//                                     event.target.parentElement.children[1].style.display = 'inline';
//                                     event.target.innerText = langConf[lang].readMore;
//                                 }
//                             }}>{`... ${langConf[lang].readMore}`}
//                         </a>
//                     </div>
//                 </div>
//                 <div className="col-12"></div>
//                 <div className="col-12"></div>
//                 <div className="col-12"></div>
//                 <div className="col-12"></div>
//                 <div className="col-6 col-xs-0"></div>
//                 <div className="col-6 col-xs-12">
//                     <ShoppingButton
//                         lang={this.props.lang}
//                         //Variables
//                         param={this.props.itemNo}
//                         param2={1}
//                         tableView={false}
//                         btnClassName={"addToCart"}
//                         btnDir={"left"}
//                         btnSize={``}
//                         btnColor={"#509a55"}
//                         iconClass={"plus icon"}
//                         isDisabled={isDisabled}
//                         isVisible={true}
//                         //Methods
//                         onClick={this.props.addToCart}
//                         updateItemCount={this.updateItemCount}
//                     />
//                     {/* <div className="col-12 col-xs-0"></div> 
//                 <div className="col-12 col-xs-0"></div>
//                 <div className="col-12 col-xs-0"></div>
//                 <div className="col-12 col-xs-0"></div> */}
//                     <div className="col-6" style={lang === 'hebrew' ? {} : {}}>
//                         <button className={`ui blue button`} onClick={this.handleBuyNowClick} style={{}}>
//                             {langConf[lang].buyNow}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }